// Stock helpers — a size is sold-out when `stock === 0`; a product is
// sold-out when every size has `stock === 0`. Missing stock fields are
// treated as "in stock" so legacy rows keep working.

export function isSizeSoldOut(size) {
  if (!size || size.stock == null) return false;
  return Number(size.stock) <= 0;
}

export function isProductSoldOut(product) {
  const sizes = product?.sizes || [];
  if (sizes.length === 0) return false;
  // Only consider it sold-out if EVERY size has an explicit stock of 0.
  // If none of the sizes carry a `stock` field, treat as in-stock.
  const anyWithStock = sizes.some((s) => s.stock != null);
  if (!anyWithStock) return false;
  return sizes.every((s) => Number(s.stock || 0) <= 0);
}

export function firstInStockSize(product) {
  const sizes = product?.sizes || [];
  const avail = sizes.find((s) => !isSizeSoldOut(s));
  return avail || sizes[0] || null;
}
